import { NgModule } from '@angular/core';
import { AddSpaceBeforeCapitals, StripSpacesPipe } from './stripSpaces.pipe';
import { TrimStringPipe } from './trimString.pipe';
import { DateFormatPipe, TimeFormatPipe } from './date-format.pipe';
import { FileSizePipe } from './fileSize.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { PrettyJsonPipe } from './pretty-json.pipe';
import { DurationFormatPipe } from './time-duration.pipe';

@NgModule({
  declarations: [
    StripSpacesPipe,
    TrimStringPipe,
    DateFormatPipe,
    FileSizePipe,
    SafeHtmlPipe,
    AddSpaceBeforeCapitals,
    TimeFormatPipe,
    PrettyJsonPipe,
    DurationFormatPipe,
  ],
  imports: [],
  exports: [
    StripSpacesPipe,
    TrimStringPipe,
    DateFormatPipe,
    FileSizePipe,
    SafeHtmlPipe,
    AddSpaceBeforeCapitals,
    TimeFormatPipe,
    PrettyJsonPipe,
    DurationFormatPipe,
  ],
})
export class AS365PipesModule {
  static forRoot() {
    return {
      ngModule: AS365PipesModule,
      providers: [],
    };
  }
}
